import type {
    TAcceptionTypes,
    TDeliveryChannel,
    TResponseAdditionalData,
    TWebSmsAuthClient,
} from './patient.types';

export interface IPatient {
    patientId?: number; // ID пациента
    num: string; // Номер медицинской карты
    lastName: string; // Фамилия
    firstName: string; // Имя
    secondName: string; // Отчество
    birthDateStr: string; // Дата рождения
    birthDate?: Date | null; // Дата рождения
    phone: string; // Телефон
    cellular: string; // Сотовый телефон
    email: string; // Почта
    addressProj: string; // Адрес проживания
    snils: string; // СНИЛС ИНН
    countLogin: number; // количество логинов
    sex: string;
    addressReg: string;
    userCardInfo?: {
        numberCard?: number;
        nameProgramm?: string;
        discount?: number;
        bonusAmount?: number;
    };
}
/* Создание пациента */
export interface ICreatePatient {
    lastName: string; // Фамилия
    firstName: string; // Имя
    secondName?: string; // Отчетсво
    birthDate: string; // ДР Формат даты = "01.12.1999"
    email?: string; // Почта
    phone?: string; // Телефон
    sex?: number; // Пол ()
    snils?: string; // СНИЛС
    inn?: string; // ИНН
    iin?: string; // ИИН (для Казахстана)
    card?: number; // номер карты пациента
    tabNum?: string; // табельный номер из мест работы
    polisNum?: string; // номер полиса
    polisSer?: string; // серия полиса
    captchaHash?: string;
}

// Параметры пациента
export interface IPatientExt {
    name: string; // Наименование
    value: string; // Значение
}

export interface IAuthData {
    login: string;
    password: string;
}

export interface IPasswordRecoveryParams {
    newPassword: string;
    newPasswordRepeat: string;
}
export interface IChangeEmail {
    email: string;
    message?: string;
}

export interface IResultEmailUpdate {
    1: string;
}

export interface ITokenAndPatientId {
    token: string;
    patientId: number;
    // ext?: IPatientExt[]; // список параметров по пациенту
}
export interface IContractSigningResponse {
    id: number;
}

export interface ISendAuthenticationCodeResponse {
    messageUuid: string;
    patientId: number;
}

export interface ICreateAuthenticationCodeResult {
    deduplicated: boolean;
    messageUuid: string;
}
export interface IDataForAuthCode {
    messageUuid: string;
    delieveryChanel: TDeliveryChannel;
    phoneOrMail: string;
}

export interface IResponseAdditionalData {
    NAME: string;
    VALUE: string;
}

export type { TPayContract, TResponseAdditionalData } from './patient.types';

export interface IResponseEsiaData {
    patientId: number;
    token: string;
    ext: TResponseAdditionalData;
}

/* Список договоров */
export interface IDogList {
    id: number; // ID
    text: string; // наименование
    mark: boolean | null; // отмечена
    url: string | null; // url для перехода
}

export interface ITemplatesOutput {
    templateId: number;
    templateName: string;
}

export interface IContractTemplateItem extends ITemplatesOutput {
    file: boolean;
    content: Buffer;
}
export interface IContractResponse {
    type: string;
    data: Uint8Array;
}

export interface IIDogSignatureData {
    id: number; // ID документа
}

export interface IResponseRegisterDB {
    id: number;
}

/* Документ у пациента */
export interface IContract {
    id: number; // ID
    dat: string; // Датат документа
    text: string; // Наименование
}

//для подписания документов в аккаунте

export interface IUnsignedPayContract {
    templateId: number; // ID
    templateName: string; // Датат документа
}

export interface ISidgnedPayContract {
    dat: string;
    id: number;
    text: string;
}

export interface IPatientFind {
    lastName: string;
    firstName: string;
    secondName?: string;
    birthDate: string;
    email?: string;
    phone?: string;
    captchaHash?: string;
    client?: TWebSmsAuthClient;
}

export const onlyCharsWithHyphenRegex = new RegExp(
    /^(?:[a-zA-Z]+(?:-[a-zA-Z]+){0,2}|[а-яА-ЯёЁ]+(?:-[а-яА-ЯёЁ]+){0,2})$/u,
);

export class IUser {
    public token?: string | null;
    public patientId?: number | null;
}

export interface IResponseGetRecordLog {
    id: number; // Иденьтификатор INT
    sessionId: string;
    datStr: string; // дата строковое "dd.mm.yyyy HH24:MI"
    date?: Date; // "dd.mm.yyyy HH24:MI"
    action: string; // Наименование активности ("AUTH")
    text: string; // Текст
    browser: string; // Браузер
    ipAddress: string; // IP адрес
    os: string; // OS
    logLevel: number; //
    success: number; // 1-нормально
    rnum: number;
    dateNormalized?: string;
}

export interface IInetuserLogSize {
    size: string; // Количество
}

/* Авторизация через телефон */
export interface IAuthPatientPhone {
    phone: string; // Телефон
    captcha: string;
    captchaSolid: string;
}

export interface IAcceptDocs {
    name: string;
    type: TAcceptionTypes;
    exist: boolean;
    url?: string;
    label: string;
}
